"use client";
import Image from "next/image";
//import Link from "next/link";
import Button from "@/Components/Button";
import { toWebp } from "@/utils/common";

interface ExploreProps {
  data?: any;
}
const Explore = ({ data }: ExploreProps) => {

  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

  return (
    <section className="relative bg-background-white text-primary-text py-[56px] xl:py-25 md:py-[80px] overflow-hidden">
      <div className="container mx-auto px-4 sm:text-left text-center relative z-10">
        <div className="grid sm:gap-[30px] gap-[24px] md:grid-cols-12 items-start w-full mb-[0] ">
          <div className="xl:col-span-6 md:col-span-6 order-2 sm:order-1 flex h-full items-start flex-col justify-center">
            <h2 className="text-heading-1 font-bold text-primary-text mb-[10px] md:mt-[0px] max-w-[494px] mx-0 w-full text-left">
              {data?.title}
            </h2>

            <p className="text-heading-6 font-normal text-secondary-text max-w-[940px]  text-left">
              {data?.description}
            </p>

            {data?.cta?.label && data?.cta?.href && (
              <a href={data?.cta?.href} className="mt-[24px] flex mx-0 justify-start">
                <Button label={data?.cta?.label} className="mt-[16px]" />
              </a>
            )}
          </div>

          <div className="xl:col-span-6 md:col-span-6 order-1 sm:order-2">
            {data?.image?.data?.attributes?.url && (
              <Image
                src={toWebp(baseUrl + data?.image?.data?.attributes?.url)}
                alt=""
                className="w-full"
                width={1230}
                height={488}
              />  
            )}
          </div>

        </div>
      </div>
    </section>
  );
};

export default Explore;
